import { Component, Inject } from '@angular/core';
import {
  CmsDialogComponent,
  DialogData,
} from '../../../../shared/components/cms-dialog/cms-dialog.component';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-cms-confirmation-dialog',
  templateUrl: './cms-confirmation-dialog.component.html',
})
export class CmsConfirmationDialogComponent extends CmsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CmsConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    super(dialogRef, data);
  }

  speedbumpText = '';
}
